import { createSelector } from 'reselect';
import _find from 'lodash/find';

const selectModule = state => state.app;
const selectUpload = state => state.x_upload;

export const getSettings = state => state.settings.data;

export const getProjectName = createSelector(getSettings, settings => settings && settings.name);
export const getPluginSettingsValue = (pluginId, key) =>
  createSelector(getSettings, settings => {
    if (!settings) {
      return null;
    }
    const plugin = settings.plugins.find(({ id }) => id === pluginId);
    if (!plugin || !plugin.is_active) {
      return null;
    }
    const setting = (plugin.settings || []).find(({ name }) => name === key);

    if (setting && setting.value !== '' && setting.value !== null && setting.value !== undefined) {
      return setting.value;
    }
    return setting && setting.values ? setting.values : null;
  });

export default {
  getCurrency: createSelector(getSettings, settings => settings.currency),
  isPluginActive: pluginId =>
    createSelector(getSettings, settings => {
      return !!_find(settings.plugins, { id: pluginId, is_active: true });
    }),
  getHoldingCompany: createSelector(selectModule, state => {
    return state.holdingCompany;
  }),
  isOnline: createSelector(selectModule, state => {
    return state.isOnline;
  }),
  hasWifiConnection: createSelector(selectModule, state => {
    return state.network ? state.network.type === 'wifi' && state.network.isInternetReachable : false;
  }),
  isUploading: createSelector(selectUpload, ({ uploads }) => uploads.some(upload => upload.isUploading)),
  getOverallProgress: createSelector(selectUpload, ({ uploads, uploadsCount }) => {
    const overallProgress = uploads.reduce((acc, upload) => {
      return acc + (upload.isUploaded ? 100 : upload.progress);
    }, 0);

    return (overallProgress + (uploadsCount - uploads.length) * 100) / uploadsCount;
  }),
  isActive: createSelector(selectModule, state => state.isActive),
  getProjectName,
  getPluginSettingsValue,
};
